var map = {
	"./AI.svg": 455,
	"./Add.svg": 6176,
	"./ArrowDownCircle.svg": 6269,
	"./ArrowLeft.svg": 9174,
	"./ArrowPath.svg": 8655,
	"./ArrowUpCircle.svg": 1557,
	"./Baidu.svg": 8394,
	"./BiliBili.svg": 91,
	"./Bing.svg": 8660,
	"./Clear.svg": 5977,
	"./Copy.svg": 9772,
	"./Document.svg": 7193,
	"./Douban.svg": 2471,
	"./Down.svg": 5450,
	"./DuckDuckGo.svg": 462,
	"./Extension.svg": 1660,
	"./Folder.svg": 6515,
	"./Gift.svg": 8466,
	"./GitHub.svg": 7467,
	"./Google.svg": 8626,
	"./GoogleScholar.svg": 1257,
	"./Home.svg": 9380,
	"./Magnifier.svg": 8984,
	"./MinusSmall.svg": 3695,
	"./PencilSquare.svg": 6376,
	"./Photo.svg": 6955,
	"./PlusSmall.svg": 8652,
	"./Qwant.svg": 6391,
	"./RedBook.svg": 9048,
	"./SearchColor.svg": 5607,
	"./Star.svg": 6363,
	"./Trash.svg": 2412,
	"./ViewfinderCircle.svg": 1039,
	"./Wikipedia.svg": 8391,
	"./XCircle.svg": 6658,
	"./XMark.svg": 4116,
	"./Yandex.svg": 4707,
	"./ZhiHu.svg": 2678,
	"./个人中心_我的信息.svg": 4162,
	"./学校.svg": 9445,
	"./清华-个人中心2off.svg": 7373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;